










































import { formatDistanceToNow, subWeeks, isBefore } from "date-fns";
import { Component, Prop, Vue } from "vue-property-decorator";
import RouteName from "../../router/name";
import { IPost } from "../../types/post.model";
import LazyImageWrapper from "@/components/Image/LazyImageWrapper.vue";
import { displayName } from "@/types/actor";

@Component({
  components: {
    LazyImageWrapper,
  },
})
export default class PostListItem extends Vue {
  @Prop({ required: true, type: Object }) post!: IPost;
  @Prop({ required: false, type: Boolean, default: false })
  isCurrentActorMember!: boolean;

  RouteName = RouteName;

  formatDistanceToNow = formatDistanceToNow;

  displayName = displayName;

  get publishedAt(): Date {
    return new Date((this.post.publishAt || this.post.insertedAt) as Date);
  }

  get isBeforeLastWeek(): boolean {
    return isBefore(this.publishedAt, subWeeks(new Date(), 1));
  }
}
